import React from 'react';
import { withPrefix } from 'gatsby';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { setConfiguration } from 'react-grid-system';
// eslint-disable-next-line
import polyfillRepeatIE from '../utils';

import Footer from '../components/Footer';
import MobileNavigation from '../components/Navigation/mobileNavigation';
import Navigation from '../components/Navigation';

import '../sass/index.scss';

setConfiguration({ gutterWidth: 32 });

const Layout = ({ children }) => (
  <React.Fragment>
    <Helmet>
      <link rel="stylesheet" href="https://use.typekit.net/sns7oso.css" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.7.2/css/all.min.css" />
      <link rel="apple-touch-startup-image" href={withPrefix('splash/750x1294.png')} media="(device-width: 320px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" />
      <link rel="apple-touch-startup-image" href={withPrefix('splash/1242x2148.png')} media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" />
      <link rel="apple-touch-startup-image" href={withPrefix('splash/1125x2436.png')} media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" />
      <link rel="apple-touch-startup-image" href={withPrefix('splash/1536x2048.png')} media="(min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)" />
      <link rel="apple-touch-startup-image" href={withPrefix('splash/1668x2224.png')} media="(min-device-width: 834px) and (max-device-width: 834px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)" />
      <link rel="apple-touch-startup-image" href={withPrefix('splash/2048x2732.png')} media="(min-device-width: 1024px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)" />
    </Helmet>
    <div>
      <Navigation />
      <MobileNavigation width="100%" />
    </div>
    <div className="page-container">
      {children}
    </div>
    <Footer />
  </React.Fragment>
);

export default Layout;

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
